import { render, staticRenderFns } from "./LegendColorMark.vue?vue&type=template&id=2160d1ec&scoped=true&"
import script from "./LegendColorMark.vue?vue&type=script&lang=js&"
export * from "./LegendColorMark.vue?vue&type=script&lang=js&"
import style0 from "./LegendColorMark.vue?vue&type=style&index=0&id=2160d1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160d1ec",
  null
  
)

export default component.exports